import { string } from "prop-types"
import React from "react"

export default function PricingRowLabel({ label }) {
  return (
    <td className="align-start">
      <p className="text-inline">{label}</p>
    </td>
  )
}

PricingRowLabel.propTypes = {
  label: string.isRequired
}
